/** The muted note on the right of a stage panel's header. */
import { Typography } from '@mui/material';
import type { ReactNode } from 'react';

export function PanelMeta({ children }: { children: ReactNode }) {
  return (
    <Typography variant="caption" color="text.secondary" noWrap>
      {children}
    </Typography>
  );
}
